(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/thunks/get-initial-balance.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/thunks/get-initial-balance.js');
"use strict";


const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const getInitialBalance = createAsyncThunk('account/getInitialBalance', async () => await new Promise((resolve, reject) => {
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (isLoggedIn) {
    svs.components.account_balance.get(balance => {
      resolve({
        balance
      });
    });
  } else {
    reject();
  }
}));
svs.gamePackage.redux.thunks.getInitialBalance = getInitialBalance;

 })(window);